import { breakpoints } from './breakpoints';

export default function scrollTo() {
  /**
   * Do scroll
   */
  function doScroll($target, delay = 0) {
    if (!$target.length) {
      return;
    }
    let scrollTop = $target.offset().top;
    scrollTop -= $(window).width() < breakpoints.xl ? 40 : 120;

    setTimeout(function () {
      $([document.documentElement, document.body]).animate(
        {
          scrollTop,
        },
        1000
      );
    }, delay);
  }

  /**
   * Clicking on link
   */
  $('a[href^="#"]').click(function (e) {
    if ($(this).attr('href') === '#') {
      return true;
    }
    e.preventDefault();
    doScroll($($(this).attr('href')));
  });

  /**
   * Scroll to element on page load
   */
  if (window.location.hash) {
    setTimeout(function () {
      window.scrollTo(0, 0);
    }, 1);
    doScroll($(window.location.hash), 500);
  }
}
